import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { 
  Box, Typography, Card, Stack, Avatar, Dialog, 
  DialogTitle, DialogContent, DialogActions, Button,
  IconButton, Menu, MenuItem
} from '@mui/material';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import WaterIcon from '@mui/icons-material/Opacity';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import SettingsIcon from '@mui/icons-material/Settings';
import { jsPDF } from "jspdf";
import { LibreDeudaPDF } from '../../utils/LibreDeudaTemplate';
import { api } from './api';
import FacturasPorSuministro from '../../components/facturasPorSuministro';
import Hero from '../../components/Hero';
import MisPagos from '../pago/mispagos';

const iconForService = (srvDsc) => {
  const desc = srvDsc.toLowerCase();
  if (desc.includes('eléctrico')) return <ElectricBoltIcon />;
  if (desc.includes('agua')) return <WaterIcon />;
  if (desc.includes('t.p.p')) return <LocalHospitalIcon />;
  if (desc.includes('sepelio')) return <VolunteerActivismIcon />;
  if (desc.includes('alumbrado')) return <LightbulbIcon />;
  return <LightbulbIcon />;
};

const SuministroServicios = () => {
  const { id } = useParams();
  const location = useLocation();
  const { suministro } = location.state || {};

  const [servicios, setServicios] = useState([]);
  const [facturas, setFacturas] = useState([]);
  const [totalDeuda, setTotalDeuda] = useState(0);
  const [selectedCard, setSelectedCard] = useState("facturas");

  // Errores genéricos
  const [openError, setOpenError] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Menú configuración
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  // Confirmación desasociar
  const [openConfirm, setOpenConfirm] = useState(false);
  const [loadingBaja, setLoadingBaja] = useState(false);


  const handleOpenMenu = (e) => setAnchorEl(e.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  const handleCloseError = () => setOpenError(false);

  useEffect(() => {
    const fetchServicios = async () => {
      try {
        const res = await api.suministro.getServiciosBySuministro(id);
        setServicios(res || []);
      } catch (err) {
        console.error('Error al cargar servicios:', err);
      }
    };

    //descomentar fetch para no traer la factura de pruebas
    // const fetchFacturas = async () => {
    //   try {
    //     const res = await api.facturas.getFacturasSuministro(
    //       suministro?.SumNro, 
    //       suministro?.CliCod
    //     );
    //     setFacturas(res?.facturas || []);
    //     setTotalDeuda(res?.totalAcum || 0);
        
    //   } catch (err) {
    //     console.error('Error al cargar facturas:', err);
    //   }
    // };
    const fetchFacturas = async () => {
  try {
    const res = await api.facturas.getFacturasSuministro(
      suministro?.SumNro,
      suministro?.CliCod
    );

    const facturasApi = res?.facturas || [];
    const totalApi = res?.totalAcum || 0;

    const facturaPrueba = {
      cliCod: suministro?.CliCod || 12825,
      sumNro: suministro?.SumNro || 1,
      inmDom: "CALLE   7 N* 1003                       ",
      Fac1AnoCns: 2025,
      Fac1MesCns: 1,
      cliApe: "BACCA, SILVANA JANINA                   ",
      compLet: "A",
      compNro: "0001-00000001",
      compTpo: "Factura",
      fechaEmis: "2025-01-10T00:00:00Z",

      // 👉 MONTO BAJO PARA TEST
      imp1: 30,
      imp2: 0,

      pdf: "TEST_PDF_FACTURA_PRUEBA",
      servTipo: "20",
      servicio: "Servicio Solidario de Sepelio (TEST)",
      vto1: "2025-02-10T00:00:00Z",
      vto2: "1753-01-01T00:00:00Z",
    };

    const facturasFinales = [
      facturaPrueba,
      ...facturasApi,
    ];

    setFacturas(facturasFinales);
    setTotalDeuda(totalApi + facturaPrueba.imp1);

  } catch (err) {
    console.error('Error al cargar facturas:', err);
  }
};


    fetchServicios();
    fetchFacturas();
  }, [id, suministro]);

  const generarLibreDeudaPDF = async () => {
    try {
      if (!suministro) {
        setErrorTitle("Datos incompletos");
        setErrorMessage("No se encontró información del suministro.");
        setOpenError(true);
        return;
      }

      if (facturas.length > 0) {
        setErrorTitle("No es posible generar el certificado");
        setErrorMessage(
          `No se puede generar Libre de Deuda.
      Existen ${facturas.length} factura(s) pendiente(s).`
        );
        setOpenError(true);
        return;
      }

      const doc = new jsPDF('p', 'mm', 'a4');
      LibreDeudaPDF(doc, suministro);
      doc.save(`LibreDeuda_${suministro.SumNro}.pdf`);
    } catch {
      setErrorTitle("Error al generar PDF");
      setErrorMessage("Ocurrió un error generando el certificado.");
      setOpenError(true);
    }
  };

  const handleDesasociarClick = () => {
    handleCloseMenu();
    setOpenConfirm(true);
  };

  const confirmarDesasociar = async () => {
    try {
      setLoadingBaja(true);
      setOpenConfirm(false);
      await api.suministro.bajaSuministro(suministro.Id);

      setErrorTitle("Suministro desasociado");
      setErrorMessage("El suministro fue desasociado correctamente.");
      setOpenError(true);

      setTimeout(() => {
        window.location.href = "/suministros";
      }, 5000);

    } catch (e) {
      setErrorTitle("Error");
      setErrorMessage(e.message || "No se pudo desasociar el suministro.");
      setOpenError(true);
    } finally {
      setLoadingBaja(false);
      handleCloseMenu();
    }
  };


  return (
    <>
      {suministro && (
        <Hero>
          <Card
            sx={{
              mb: 3,
              p: 2,
              borderRadius: 2,
              boxShadow: 3,
              position: 'relative'
            }}
          >
            {/* Engranaje */}
            <IconButton
              size="small"
              onClick={handleOpenMenu}
              sx={{ position: 'absolute', top: 8, right: 8 }}
            >
              <SettingsIcon />
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleCloseMenu}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <MenuItem
                onClick={handleDesasociarClick}
                sx={{ color: 'error.main' }}
              >
                Desasociar suministro
              </MenuItem>
            </Menu>

            {/* Contenido */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography variant="h6" gutterBottom>
                  {suministro.CliApe} - Suministro Nº {suministro.SumNro}
                </Typography>
                <Typography>Dirección: {suministro.InmDom}</Typography>
                <Typography>Nro Socio: {suministro.CliCod}</Typography>

                <Stack direction="row" spacing={2} mt={2} flexWrap="wrap">
                  {servicios.map((s) => (
                    <Avatar
                      key={s.srvCod}
                      sx={{ bgcolor: 'primary.main', width: 50, height: 50 }}
                      title={s.srvDsc}
                    >
                      {iconForService(s.srvDsc)}
                    </Avatar>
                  ))}
                </Stack>
              </Box>

              <Box sx={{ textAlign: 'center', minWidth: 150 }}>
                <Typography variant="subtitle2">Saldo de deuda</Typography>
                <Typography variant="h6" color="error" fontWeight="bold">
                  {new Intl.NumberFormat('es-AR', {
                    style: 'currency',
                    currency: 'ARS',
                  }).format(totalDeuda)}
                </Typography>
              </Box>
            </Box>
          </Card>
        </Hero>
      )}
    {/* Tarjetas */}
    <Box
      textAlign="center"
      mb={1}
      mt={{ xs: 12, md: 3 }}
    >
      <Box p={2} maxWidth={900} mx="auto">
        <Box
          display="grid"
          gridTemplateColumns={{
            xs: 'repeat(3, 1fr)',
            sm: 'repeat(3, 1fr)',
            md: 'repeat(3, 220px)',
          }}
          gap={3}
          justifyContent="center"
          sx={{
            maxWidth: 720,
            margin: '0 auto',
          }}
        >
          {[
            {
              key: 'facturas',
              label: 'Facturas impagas',
              value: facturas.length,
              icon: <ReceiptLongIcon />,
              color: 'success.main',
            },
            {
              key: 'pagos',
              label: 'Descarga de Facturas',
              icon: <CreditCardIcon />,
              color: 'info.main'
            },
            {
              key: 'libredeuda',
              label: 'Emisión de Libre Deuda',
              icon: <ReceiptLongIcon />,
              color: 'secondary.main'
            }
          ].map((card) => {
            let formattedValue = card.value;

            if (card.key === 'facturas' && card.value !== undefined) {
              formattedValue = new Intl.NumberFormat('es-AR', {
                maximumFractionDigits: 0,
              }).format(card.value);
            }

            return (
              <Card
                key={card.key}
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  justifyContent: 'center',
                  alignItems: 'center',
                  p: 2,
                  cursor: 'pointer',
                  border: selectedCard === card.key ? '1px solid #64AE37' : 'none',
                  transition: '0.2s',
                  '&:hover': { transform: 'translateY(-4px)', boxShadow: 6 },
                  width: { xs: '100%', md: 220 },
                  height: { xs: 140, md: 80 },
                  gap: 2,
                }}
                onClick={() =>
                  card.key === 'libredeuda'
                    ? generarLibreDeudaPDF()
                    : setSelectedCard(card.key)
                }
              >
                <Avatar
                  sx={{
                    bgcolor: card.color,
                    mb: { xs: 1, md: 0 },
                    mr: { xs: 0, md: 2 },
                    width: 48,
                    height: 48
                  }}
                >
                  {card.icon}
                </Avatar>

                <Box
                  sx={{
                    textAlign: { xs: 'center', md: 'left' },
                    flexGrow: 1,
                  }}
                >
                  <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="subtitle2" component="span">
                      {card.label}
                    </Typography>

                    {card.value !== undefined && (
                      <>
                        <Typography component="span" sx={{ mx: 0.5 }}>|</Typography>
                        <Typography fontWeight="bold" variant="subtitle2" component="span">
                          {formattedValue}
                        </Typography>
                      </>
                    )}
                  </Box>
                </Box>
              </Card>
            );
          })}
        </Box>
      </Box>
    </Box>

      {/* Contenido dinámico */}
      <Box p={1} maxWidth={900} mx="auto">
        {selectedCard === "facturas" && (
          <>
            <Typography variant="h5" gutterBottom fontWeight="bold">
              Facturas <span style={{ color: "#64AE37" }}>impagas</span>
            </Typography>
            <FacturasPorSuministro impagas={facturas} id={id} />
          </>
        )}

        {selectedCard === "pagos" && (
          <>
            <Typography variant="h5" gutterBottom fontWeight="bold">
              Mis <span style={{ color: "#64AE37" }}>pagos</span>
            </Typography>
            <MisPagos
              suministroId={suministro?.SumNro}
              cliCod={suministro?.CliCod}
            />
          </>
        )}
      </Box>

      {/* Confirmación */}
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirmar acción</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Estás seguro que querés desasociar este suministro de tu cuenta?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>Cancelar</Button>
            <Button
              color="error"
              variant="contained"
              onClick={confirmarDesasociar}
              disabled={loadingBaja}
            >
              Desasociar
            </Button>
        </DialogActions>
      </Dialog>

      {/* Error */}
      <Dialog open={openError} onClose={handleCloseError}>
        <DialogTitle>{errorTitle}</DialogTitle>
        <DialogContent>
          <Typography sx={{ whiteSpace: 'pre-line' }}>
            {errorMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseError} variant="contained">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SuministroServicios;

